import productCarousel from '../../jquery/lsag.productcarouselcomponent';

class RecommendedProductsService {
    /*@ngInject*/
    constructor($log, $http, $timeout, $rootScope, CommonService) {
        this.$log = $log;
        this.$http = $http;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.CommonService = CommonService;
    }

    fillProductCarousel(componentId, productCodes) {
        let url = this.CommonService.getBaseUrl() + '/ajax/recommendedProducts?productCodes=' + productCodes;

        let searchFor = '#' + componentId + ' .js-carousel-lazy';

        this.$http.get(url, null)
            .then((response) => {
                $(searchFor).html(response.data);
                this.$timeout(() => {
                    if ($(searchFor).find('.c-carousel__item').length) {
                        if ($('.js-carousel__multi').length) {
                            productCarousel.extractHeadlines();
                            productCarousel.buildTabBar();
                            productCarousel.bindTabEvents();
                        }
                        productCarousel.buildCarousel($(searchFor));
                    }
                }, 1);

            }, (error) => {
                this.$log.error('Error in recommendedProducts: ' + error.status + ' ' + error.statusText);
            });
    }

    requestRecommendedProducts(componentId, componentLogic, maxProducts, successCallback) {
        this.$log.debug('Get recommendedProducts from Emarsys');
        executeScarabWithDelay(Date.now(), function() {
            // Use these ids for testing
            //ScarabQueue.push(['include', 'item', 'in', ['1101301718', '1101405360', '4623506772']]);
            // Request personalized recommendations.
            ScarabQueue.push(['recommend', {
                logic: componentLogic,
                containerId: componentId,
                success: successCallback,
                limit: maxProducts,
            }]);
        });
    }
}

export default RecommendedProductsService;
